import { render } from "./YPHome.vue?vue&type=template&id=17dbbd92"
import script from "./YPHome.vue?vue&type=script&lang=js"
export * from "./YPHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__